import type { FC } from 'react';
import type { Control } from 'react-hook-form';

import { SegmentedControl } from '../../../../components/reactHookFormMantine/SegmentedControl.tsx';
import { useI18n } from '../../../../hooks/useI18n.ts';
import type { IncompleteEventFormComplete } from '../../IncompleteEventForm/schema.ts';
import { LiveEventSettings } from './LiveEventSettings.tsx';
import { OnlineEventSettings } from './OnlineEventSettings.tsx';
import { SecretEventAlert } from './SecretEventAlert.tsx';

export const EventTypeSegmentedControl: FC<{
  control: Control<IncompleteEventFormComplete>;
  activeEventType: string;
}> = ({ control, activeEventType }) => {
  const { t } = useI18n();

  return (
    <>
      <SegmentedControl
        control={control}
        data={[
          { value: 'live', label: t('where-and-when_segment--live') ?? 'Live' },
          {
            value: 'online',
            label: t('where-and-when_segment--online') ?? 'Online',
          },
          {
            value: 'secret',
            label: t('where-and-when_segment--secret') ?? 'Secret Location',
          },
        ]}
        name="eventType"
      />
      {activeEventType === 'live' && <LiveEventSettings control={control} />}
      {activeEventType === 'online' && <OnlineEventSettings control={control} />}
      {activeEventType === 'secret' && <SecretEventAlert />}
    </>
  );
};
